import React from "react";

export default function Logo({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 101 22"
      className={className}
    >
      <path
        fill="#C00"
        d="M23.8 15.8c-1.5 2.2-4.1 3.6-6.9 3.6-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5c1.6 0 3.2.5 4.5 1.3L16.9 11l8.4-4.9C24 4 21.9 2.4 19.6 1.5 17.7.8 15.7.4 13.6.4s-4.1.4-6 1.1C5.7 2.2 4 3.4 2.7 5 1.4 6.6.6 8.7.6 11s.8 4.3 2.1 6c1.3 1.6 3 2.8 4.9 3.5 1.9.7 3.9 1.1 6 1.1 1.3 0 2.7-.2 3.9-.4 2.6-.6 4.9-2 6.7-3.9l-.4-1.5zM59.3 4.1c-.5 0-.9.1-1.3.3l-4.9 2.3c-.2-1.5-1.5-2.6-3-2.6-.5 0-.9.1-1.3.3l-6 2.8H47V21h6.2V8.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V21h6.2V7.2c0-1.7-1.4-3.1-3.1-3.1zM97.9 4.1c-.5 0-.9.1-1.3.3l-4.9 2.3c-.2-1.5-1.5-2.6-3-2.6-.5 0-.9.1-1.3.3l-6 2.8h4.2V21h6.2V8.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V21h6.2V7.2c0-1.7-1.4-3.1-3.1-3.1z"
      />
      <path
        fill="#C00"
        d="M73.7 4.1C68.9 4.1 65 8 65 12.8c0 4.8 3.9 8.7 8.7 8.7 4.8 0 8.7-3.9 8.7-8.7 0-4.8-3.9-8.7-8.7-8.7zm2 16.1c-1 .3-2.1-.3-2.4-1.4l-3-11.1c-.3-1 .3-2.1 1.4-2.4 1-.3 2.1.3 2.4 1.4l3 11.1c.2 1.1-.4 2.1-1.4 2.4zM37.2 15.9c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1zm1.5 5.1h6.2L41.4 7.8c-.6-2.1-2.5-3.7-4.8-3.7-.6 0-1.2.1-1.7.3l-7.6 2.8H35l1.3 5c-1.3-1.1-3-1.8-4.9-1.8-1.4 0-2.7.4-3.8 1-.9.5-1.6 1.2-2.2 2-.4.7-.7 1.6-.7 2.5 0 .9.3 1.8.7 2.5.5.9 1.3 1.6 2.2 2 1.1.6 2.4 1 3.8 1 2.6 0 5-1.3 6.4-3.3l.9 2.9z"
      />
    </svg>
  );
}
